/**
 * @generated SignedSource<<06c107fde83373fbe9edd100e1302868>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type PublishCheckinInput = {
  checkinId: string;
  clientMutationId?: string | null;
};
export type publishCheckinMutation$variables = {
  input: PublishCheckinInput;
};
export type publishCheckinMutationVariables = publishCheckinMutation$variables;
export type publishCheckinMutation$data = {
  readonly publishCheckin: {
    readonly errors: ReadonlyArray<string | null> | null;
  } | null;
};
export type publishCheckinMutationResponse = publishCheckinMutation$data;
export type publishCheckinMutation = {
  variables: publishCheckinMutationVariables;
  response: publishCheckinMutation$data;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "PublishCheckinPayload",
    "kind": "LinkedField",
    "name": "publishCheckin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "errors",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "publishCheckinMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "publishCheckinMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "fb673218c26494e9eaa9a701cdfbee94",
    "id": null,
    "metadata": {},
    "name": "publishCheckinMutation",
    "operationKind": "mutation",
    "text": "mutation publishCheckinMutation(\n  $input: PublishCheckinInput!\n) {\n  publishCheckin(input: $input) {\n    errors\n  }\n}\n"
  }
};
})();

(node as any).hash = "362d0bf1b944ec53c482eaa7a953d2d0";

export default node;
